import { ContinueResponse, Endpoint, SignSubmitRequest } from '../class/class';
import { handleContinueResponse, httpRequest, logd } from '../utils/utils';

import ResponseInfo = AppModel.ResponseInfo;

export class SignSubmit extends Endpoint {
  static endpoint = 'qsl_sign_submit';

  constructor() {
    super();
  }

  async doSignSubmit(responseInfo: ResponseInfo): Promise<void> {
    const req = new SignSubmitRequest(responseInfo);
    logd(() =>
      console.log('%c doSignSubmit -> %c', 'color:#F60', 'color:#000', req),
    );
    const resp = await httpRequest<ContinueResponse>(
      this.baseUrl + SignSubmit.endpoint,
      req,
    );
    const event = new CustomEvent('rass:sign-submit:success');
    window.dispatchEvent(event);
    const continueResponse = new ContinueResponse(resp.json);
    handleContinueResponse(continueResponse, 'success');
  }
}
